/**
 * Main Application Entry Point
 * AY Maps - Geopolitical Conflict Maps
 */

// CSS imports
import './styles/main.css';

// Firebase and external libraries
import { getLinkData } from "./config/firebase";

// Translation utilities
import { setupLanguage, showModal } from "./utils/translation";

// Application modules
import { initializeMap } from './components/mapConfig';
import { processCountries } from './components/countryManager';
import { setDataLink } from './components/eventManager';
import { initializeFilters } from './components/filters';
import { showLoader, hideLoader, setLoaderMessage } from './components/loadingIndicator';

/**
 * Initialize the application
 */
async function initializeApp() {
    try {
        console.log('Starting application initialization...');
        setLoaderMessage('Initializing map…');
        
        // Wait for Leaflet to be available
        if (typeof L === 'undefined') {
            console.error('Leaflet library not loaded!');
            return;
        }
        
        console.log('Leaflet available, initializing map...');
        
        // Show modal and setup language
        // showModal();
        setupLanguage();

        // Initialize map and controls
        initializeMap();
        console.log('Map initialized');

        // Initialize filters
        initializeFilters();
        console.log('Filters initialized');

        // Get data link from Firebase
        const link = await getLinkData();
        setDataLink(link);
        console.log('Data link set');

        // Process and load countries
        await processCountries();
        console.log('Countries processed');

        // Setup navbar collapse behavior
        $('.navbar-nav li a:not(.dropdown-toggle)').on('click', function () {
            $('.navbar-collapse').collapse('hide');
        });
        
        console.log('Application initialized successfully!');
    } catch (error) {
        console.error('Error initializing application:', error);
    }
}

/**
 * Wait for all dependencies to load
 */
function waitForDependencies() {
    return new Promise((resolve) => {
        const checkDependencies = () => {
            if (typeof L !== 'undefined' && typeof $ !== 'undefined' && typeof d3 !== 'undefined') {
                console.log('All dependencies loaded', {
                    leaflet: typeof L !== 'undefined',
                    jquery: typeof $ !== 'undefined',
                    d3: typeof d3 !== 'undefined'
                });
                resolve();
            } else {
                console.log('Waiting for dependencies...', {
                    leaflet: typeof L !== 'undefined',
                    jquery: typeof $ !== 'undefined',
                    d3: typeof d3 !== 'undefined'
                });
                setTimeout(checkDependencies, 100);
            }
        };

        checkDependencies();
    });
}

/**
 * Window Load Event
 */
window.addEventListener('load', async () => {
    console.log('Window loaded, waiting for dependencies...');
    showLoader('Preparing map…');

    try {
        await waitForDependencies();
        await initializeApp();
    } catch (error) {
        console.error('Error during application startup:', error);
    } finally {
        hideLoader();
    }
});
